import React from 'react';

const Arrow = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={className}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24"
      cy="24"
      r="23.5"
      transform="matrix(-1 0 0 1 48 0)"
      stroke="currentColor"
    />
    <path
      d="M21.2929 19.2929C21.6834 18.9024 22.3166 18.9024 22.7071 19.2929C23.0976 19.6834 23.0976 20.3166 22.7071 20.7071L20.4142 23H30C30.5523 23 31 23.4477 31 24C31 24.5523 30.5523 25 30 25H20.4142L22.7071 27.2929C23.0976 27.6834 23.0976 28.3166 22.7071 28.7071C22.3166 29.0976 21.6834 29.0976 21.2929 28.7071L17.2929 24.7071C16.9024 24.3166 16.9024 23.6834 17.2929 23.2929L21.2929 19.2929Z"
      fill="currentColor"
    />
  </svg>
);

export default Arrow;
